// src/app/modules/commissionDefault/core/CommissionDefault.utils.ts
/** valida hasta 4 decimales */
export const hasUpTo4Decimals = (n: number) =>
  Number.isFinite(n) && Number.isFinite(parseFloat(n.toFixed(4)))

/** regla: % => 0..100 con hasta 4 decimales; $ => >=0 con hasta 4 decimales */
export function validateValue(value: number, isPercentage: boolean): boolean {
  if (isNaN(value) || value < 0) return false
  if (!hasUpTo4Decimals(value)) return false
  return isPercentage ? value <= 100 : true
}

/** convierte "3,5" -> 3.5 (número) */
export const parseInput = (raw: string): number => parseFloat(raw.replace(',', '.'))

/** muestra con coma como separador, respetando 4 decimales cuando existan */
export const fmt = (n: number | string) => {
  if (n === null || n === undefined || n === '') return ''
  const v = typeof n === 'string' ? parseInput(n) : n
  if (Number.isNaN(v)) return ''
  // recorta a 4 decimales sin forzar ceros
  const fixed = parseFloat(v.toFixed(4)).toString()
  return fixed.replace('.', ',')
}
